import { NavLink } from 'react-router-dom';

import {
  desktopNavItems,
  unAuthenticatedNavItems,
} from '@/configs/nav/nav-items';
import { useAuth } from '@/lib/hooks/useAuth';
import { cn } from '@/lib/utils/cn';
import { filterNavItems } from '@/lib/utils/filterNavItems';
import { useSettingsStore } from '@/store';

export const DesktopMenu = () => {
  const { settings } = useSettingsStore();
  const { isAuthenticated } = useAuth();
  const themedUi = settings?.ui?.theming?.themedUi;
  const allowedPages = settings?.ui?.pages_sections?.pages;
  const filteredNavItems = filterNavItems(
    isAuthenticated ? desktopNavItems : unAuthenticatedNavItems,
    allowedPages
  );

  return (
    <ul className="hidden lg:flex items-center gap-6 h-full">
      {filteredNavItems.map((item, i) => (
        <li key={i} className="h-full">
          <NavLink
            to={item.path}
            data-testid="desktop-menu-left-nav-links"
            className={({ isActive }) =>
              cn(
                'border-b-2 transition-all text-sm h-full flex items-center',
                isActive
                  ? themedUi
                    ? 'border-primary-foreground'
                    : 'border-primary'
                  : 'border-transparent'
              )
            }
          >
            {item.title}
          </NavLink>
        </li>
      ))}
    </ul>
  );
};
